<label
  bind:this={element}
  use:useActions={use}
  use:forwardEvents
  class={classMap({
    [className]: true,
    'mdc-deprecated-list-item__text': true,
  })}
  for={inputProps ? inputProps.id : undefined}
  {...$$restProps}><slot /></label
>

<script>var _a;
import { getContext } from 'svelte';
import { get_current_component } from 'svelte/internal';
import { forwardEventsBuilder, classMap, useActions, } from '@smui/common/internal';
const forwardEvents = forwardEventsBuilder(get_current_component());
// Remember to update types file if you add/remove/rename props.
export let use = [];
let className = '';
export { className as class };
let element;
let inputProps = (_a = getContext('SMUI:generic:input:props')) !== null && _a !== void 0 ? _a : {};
export function getElement() {
    return element;
}
</script>
